module.exports = __webpack_public_path__ + "static/media/bg-card-verso.8fe85316.svg";